import useSWR from 'swr';
import { fetcher } from 'util/Api';

function useProfile() {
  const { data, error, mutate } = useSWR('/api/v1/me', fetcher, {
    revalidateOnFocus: false,
    revalidateOnMount: false,
  });
  return {
    data,
    loading: !error && !data,
    error,
    mutate,
  };
}

export default useProfile;
